<template>
    <v-card
        component="Voices"
        :loading="getActorsLoading"
        :disabled="getActorsLoading"
        :class="{
            'small-design': this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs,
            'xs-design': this.$vuetify.breakpoint.xs,
        }"
    >
        <voices-header :count="getTotalCount" @search="onSearch" />
        <voices-lang />
        <voices-list ref="voiceList" :list="getAdminActors" />
        <!-- <voices-footer /> -->

        <div class="text-center">
            <v-pagination
                :value="getPage"
                :length="getPageCount"
                :disabled="!getPageCount"
                :total-visible="6"
                @input="onPaginate"
                circle
            ></v-pagination>
        </div>
    </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import _debounce from 'lodash/debounce';

import VoicesLang from '@/components/Project/Voices/VoicesLangs';
import VoicesHeader from '@/components/Project/Voices/VoicesHeader';
import VoicesFooter from '@/components/Project/Voices/VoicesFooter';
import VoicesList from '@/components/Project/Voices/VoicesList';

export default {
    name: 'Voices',

    components: {
        VoicesList,
        VoicesFooter,
        VoicesHeader,
        VoicesLang,
    },

    mounted() {
        // Initial actors request
        this.appendActorsFilters({ include: ['hasPhotos'] });
        this.onResize();

        this.debouncedResize = _debounce(() => {
            this.onResize();
        }, 500);

        window.addEventListener('resize', this.debouncedResize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.debouncedResize);
    },

    methods: {
        ...mapActions(['loadActors']),
        ...mapMutations(['appendActorsFilters']),

        calcLimit() {
            const height = this.$refs.voiceList.$el.clientHeight;
            const voiceHeight = this.getIsSmallerScreen ? 33 : 40;
            return Math.floor(height / voiceHeight);
        },

        onResize() {
            this.appendActorsFilters({ limit: this.calcLimit() });
            this.loadActors();
        },

        onPaginate(page) {
            this.appendActorsFilters({ page });
            this.loadActors();
        },

        onSearch(search) {
            this.appendActorsFilters({ search, page: 1 });
            this.loadActors();
        },
    },

    computed: {
        ...mapGetters([
            'getAdminActors',
            'getActorsLoading',
            'getActorsFilters',
            'getActorsMeta',
            'getIsSmallerScreen',
            'getSelectedCharacter',
        ]),

        getPage() {
            return this.getActorsFilters?.page || 1;
        },

        getPageCount() {
            return this.getActorsMeta?.pagination?.total_pages || 0;
        },

        getTotalCount() {
            return this.getActorsMeta?.pagination?.total || 0;
        },

        page: {
            get() {
                return this.getActorsFilters.page;
            },
            set(page) {
                this.appendActorsFilters({ page });
            },
        },
    },
};
</script>

<style lang="less">
@import '~@variables';

// LISTS
[component='Voices'] {
    position: relative;

    &.v-card--loading {
        overflow: visible !important;
    }

    .v-card__progress {
        //top: 41px !important;
        height: 4px;
        position: absolute;
    }

    .v-pagination__item,
    .v-pagination__navigation {
        width: 28px !important;
        min-width: 28px !important;
        height: 28px !important;
        min-height: 28px !important;
        font-size: 13px;

        .v-icon {
            color: @primary;
        }

        &.v-pagination__item--active {
            background-color: @primary !important;
        }

        &:before {
            width: 28px !important;
            min-width: 28px !important;
            height: 28px !important;
        }
    }
}
</style>
